var gallery = (function() {
    var pswpElement = document.querySelectorAll('.pswp')[0]
    var items = []
    var $galEl = $('.gallery-component')
    var $items = $galEl.find('a')
    var defaultW = 800;
    var defaultH = 600;

    $items.each(function(index) {
      //get dimensions
      var W = defaultW
      var H = defaultH
      if ($(this).data('dim')) {
        var dim = $(this).data('dim').split('x')
        W = dim[0]
        H = dim[1]
      }
      items.push({
        src: $(this).attr('href'),
        w: W,
        h: H
      })
    })

    var options = {
      index: 0,
      zoomEl: true,
      shareEl: false,
    }

    var gallery = null

    $galEl.delegate('a', 'click', function(e) {
      e.preventDefault()
      options.index = $items.index($(this))
      console.log($items.index($(this)))
      open()
    })

    function open() {
      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
      gallery.init()
    }
  })()
  /*
  $('.gallery-component').magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: {
      enabled: true
    },
  });*/



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/gallery.js